import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe, Phone, MapPin } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "./About";

export default function Agencies() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/agencies").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div>
      <PageHero kicker="Our partners" title="Agencies & property partners" subtitle="Meet some of the trusted agencies advertising properties on Homio." />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
        {items === null ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-52 bg-muted rounded-2xl animate-pulse" />)}</div>
        ) : items.length === 0 ? (
          <div className="text-center py-20 text-muted-foreground" data-testid="agencies-empty">No agency profiles are available yet.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((a) => (
              <Link key={a.id} to={`/agencies/${a.slug}`} className="bg-white rounded-2xl border border-border p-6 hover:shadow-lg transition-shadow" data-testid={`agency-${a.slug}`}>
                {a.logo ? <img src={a.logo} alt={a.name} className="w-14 h-14 rounded-xl object-contain" /> : <div className="w-14 h-14 rounded-xl bg-[#111827] text-white flex items-center justify-center text-xl font-bold font-display">{a.name?.[0]}</div>}
                <h3 className="mt-4 font-display text-xl font-bold text-[#111827]">{a.name}</h3>
                {a.description && <p className="mt-2 text-sm text-muted-foreground line-clamp-3">{a.description}</p>}
                <div className="mt-4 space-y-1.5 text-sm text-muted-foreground">
                  {a.service_areas?.length > 0 && <p className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {a.service_areas.join(", ")}</p>}
                  {a.public_phone && <p className="flex items-center gap-2"><Phone className="w-4 h-4" /> {a.public_phone}</p>}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
